import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SavedReportView } from '../../../../../models/saved-report-view';


@Component({
  selector: 'app-saved-report-view-toolbar',
  templateUrl: './saved-report-view-toolbar.component.html',
  styleUrls: ['./saved-report-view-toolbar.component.css']
})
export class SavedReportViewToolbarComponent {
  @Input() savedView: SavedReportView | null = null;
  @Input() loadingSavedView = false;
  @Input() savedViewEdited = false;
  @Input() personalDefaultViewId: number | undefined;
  @Input() organizationDefaultViewId: number | undefined;

  @Output() renameView = new EventEmitter<void>();
  @Output() deleteView = new EventEmitter<void>();
  @Output() saveChanges = new EventEmitter<void>();
  @Output() saveAsNew = new EventEmitter<void>();
}
